import React, { Component } from 'react';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import helpers from 'helpers';
import StyledReactTable from 'components/molecules/StyledReactTable';
import moment from 'moment';
import CellDiv from 'components/molecules/tables/components/CellDiv';

class CrossChannelDataTable extends Component {
    constructor(props) {
        super(props);
        this.auditTableInstance = React.createRef();
    }

    getColumns() {
        return [
            {
                Header: 'User Email',
                accessor: 'email',
            },
            {
                Header: 'Model',
                accessor: 'model',
            },
            {
                Header: 'Changed Field',
                accessor: 'touchedField',
            },
            {
                Header: 'Previous Value',
                accessor: 'previous',
                Cell: props => (!props.value ? <em>(null)</em> : JSON.stringify(props.value)),
            },
            {
                Header: 'Current Value',
                accessor: 'current',
                Cell: props => (!props.value ? <em>(null)</em> : JSON.stringify(props.value)),
            },
            {
                Header: 'Last Updated',
                accessor: 'updatedAt',
                Cell: props => <CellDiv value={moment(props.value).format('MM-DD-YYYY')} />,
            }
        ];
    }

    render() {
        const data = this.props.data;
        return (
            <ContentTile padding={helpers.contentPadding('table')}>
                <ContentHeader tableData={data} exportName={'entity-revision-history'} type={'table'}>Revision History</ContentHeader>
                <StyledReactTable
                    data={data}
                    ref={this.auditTableInstance}
                    pageSize={data.length < 25 ? data.length : 25}
                    getTheadThProps={() => ({
                        style: {
                            backgroundColor: '#E2E2E2',
                        }
                    })}
                    columns={this.getColumns()}
                    defaultSorted={[{
                        id: 'updatedAt', desc: true
                    }]}
                    className="-highlight"
                    showPagination={data.length > 25}
                />
            </ContentTile>
        );
    }
}

export default CrossChannelDataTable;



// WEBPACK FOOTER //
// ./src/containers/tables/AuditTable.js